angular
  .module("accordionPracticeDetails.components", [])
  .component("accordionPracticeDetails", {
    templateUrl: "ng/components/accordionPracticeDetails/accordionPracticeDetails.view.html",
    bindings: {
      model: "=",
      vendor: "<",
      customer: "<",
      // Optional
      nextStepIsEnabled: "=",
      onAccordionPracticeDetailsOk: "&?",
      onAccordionPracticeDetailsNotOk: "&?"
    },
    controllerAs: "accordionPracticeDetailsCtrl",
    controller: function accordionPracticeDetailsController(
      $scope,
      $financialService,
      PracticeDetail
    ) {
      var self = this;

      // Model - Extended fields
      self.modelExt = {
        productInputDataMap: [], // [{'cdPrd': res.cdPrd, 'dsPrd': res.dsPrd}, ...]
        productInputData: [], // ['Luca', 'Gennaro', 'Yury']
        productPicks: [],
        facilitationInputDataMap: [], // {'cdAgv': res.cdAgv, 'dsAgv': res.dsAgv}, ...]
        facilitationInputData: [], // ['Luca', 'Gennaro', 'Yury']
        facilitationPicks: [],
        conventionInputDataMap: [],
        conventionInputData: [], // ['Luca', 'Gennaro', 'Yury']
        conventionPicks: [],
        modalityInputDataMap: [],
        modalityInputData: [], // ['Luca', 'Gennaro', 'Yury']
        modalityPicks: []
      };

      self.$onInit = function () {
        self.model = self.model || null;

        if (self.model == null) {
          self.model = Object.assign({}, PracticeDetail.build());
        }

        // Init Tags
        $financialService.getAllLeasingProducts()
          .then(function (list) {
            self.modelExt.productInputData = list;
          });

        $financialService.getAllConventions()
          .then(function (list) {
            self.modelExt.conventionInputData = list;
          });

        $financialService.getAllPaymentModes()
          .then(function (list) {
            self.modelExt.modalityInputData = list;

          });

        // $financialService.getDelayDays(self.model.product)
        //   .then(function (response) {
        //     console.log('$financialService.getDelayDays - response', response);
        //     angular.forEach(response, function (res, resIndex) {
        //       console.log('$financialService.getDelayDays - res', res);
        //       self.modelExt.productInputDataMap.push({
        //         'cdPrd': res.cdPrd,
        //         'dsPrd': res.dsPrd
        //       });
        //       self.modelExt.productInputData.push(res.dsPrd);
        //     });
        //   });



        $financialService.getAllFacilitations(self.model.product)
          .then(function (list) {
            self.modelExt.facilitationInputData = list
          });


        self.nextStepIsEnabled = $scope.change();
      };

      self.onSelectChange = function (field) {
        $scope.change(field);
        console.log("self.model - change", self.model);
      };

      self.onCheckboxChange = function (field) {
        if (!field) return;
        field.managePractice = !field.managePractice;
        $scope.change(field);
      };

      // Get self.modelExt
      self.getModelExtProductInputData = function () {
        return self.modelExt.productInputData;
      };

      self.getModelExtFacilitationInputData = function () {
        return self.modelExt.facilitationInputData;
      };

      self.getModelExtConventionInputData = function () {
        return self.modelExt.conventionInputData;
      };

      self.getModelExtModalityInputData = function () {
        return self.modelExt.modalityInputData;
      };

      $scope.change = function () {
        if (
          self.model.referenceClient &&
          self.model.referenceClient.ndg &&
          self.model.referenceClient.name &&
          self.model.referenceClient.surname &&
          self.model.product &&
          self.model.amount &&
          self.model.facilitation &&
          self.model.convention &&
          self.model.supplier &&
          self.model.expectedVerbalSignatureDate &&
          self.model.constructionYear &&
          self.model.goodDescription &&
          self.model.vendorPaymentPercentage &&
          self.model.vendorPaymentAmount &&
          self.model.modality &&
          self.model.extension
        ) {
          self.onAccordionPracticeDetailsOk();
        } else {
          self.onAccordionPracticeDetailsNotOk();
        }
        console.log(
          "nextStepIsEnabled - accordionPracticeDetails",
          self.nextStepIsEnabled
        );
      };
    }
  });